import logo from './assets/images/logo.png'
import AdmissionInformationSession from './assets/files/2020학년도_하반기_학교설명회.pdf'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="logo-wrapper">
          <img className="logo" src={logo} alt="logo" />
        </div>
        <div className="header-text">
          <p className="row">
            <span className="bold">민족사관고등학교</span>
            에서
          </p>
          <p className="row">
            <span className="bold">2021년 전액장학생</span>
            을 모집합니다.
          </p>
        </div>
      </header>
      <div className="section">
        <div className="section-title light">1. 모집인원</div>
        <div className="highlight-text">
          <span className="highlight-text-wrapper regular">4명
            <div className="highlight"></div>
          </span>
        </div>
        <div className="section-additional-info light">
          (한샘 DBEW 장학생 3명, 민사고 동문 장학생 1명)
        </div>
        <div className="divider"></div>
      </div>
      <div className="section">
        <div className="section-title light">2. 장학금 지원내역</div>
        <div className="highlight-text">
          <span className="highlight-text-wrapper regular">재학 기간
            <div className="highlight"></div>
          </span>
        </div>
        <div className="highlight-text">
          <span className="highlight-text-wrapper regular">교육비 전액
            <div className="highlight"></div>
          </span>
        </div>
        <div className="section-additional-info light">
          (입학금, 수업료, 기숙사비 및 제반 경비 일체)
        </div>
        <div className="divider"></div>
      </div>
      <div className="section">
        <div className="section-title light">3. 지원자격</div>
        <div className="box-wrapper">
          <div className="box">
            <div className="box-title regular">한샘 DBEW 장학생</div>
            <div className="box-description light">
              <p>한샘DBEW연구재단의 목표와 전략에 대해 지속적으로 관심을 가지고 향후 DBEW 포럼 참석 등 재단 활동에 공헌하고자 하는 자로 <span className="bold">다음 중 하나에 해당하는 자</span></p>
              <p>&#9312; 국민기초생활 보장법 제2조 제1호에 따른 수급권자 또는 그 자녀</p>
              <p>&#9313; 국민기초생활 보장법 제2조 제10호에 따른 차상위계층 또는 그 자녀</p>
              <p>&#9314; 가정형편이 어려운 자로 학교장 또는 기초자치단체장의 추천을 받은 자</p>
            </div>
          </div>
        </div>
        <div className="box-wrapper">
          <div className="box">
            <div className="box-title regular">민사고 동문 장학생</div>
            <div className="box-description light">
              <p>민사고 설립이념에 따라 민족을 위한 봉사와 참된 지도자의 자세를 견지한 마음을 가진 자이며 졸업 후 자랑스러운 동문으로서 동문회 활동을 위해 노력하고자 하는 자로 <span className="bold">다음 중 하나에 해당하는 자</span></p>
              <p>&#9312; 기준 중위소득 이하인 자</p>
              <p>&#9313; 가정형편이 어려운 자로 학교장 또는 기초자치단체장의 추천을 받은 자 <span className="bold">(소득 조건 없음)</span></p>
            </div>
          </div>
        </div>
        <div className="divider"></div>
      </div>
      <div className="section">
        <div className="section-title light">4. 온라인 학교설명회 안내</div>
        <div className="highlight-text">
          <span className="highlight-text-wrapper regular narrow">11/18 (수)
            <div className="highlight"></div>
          </span>
        </div>
        <div className="section-additional-info light">
          <p>ZOOM을 통해 <span className="bold">온라인 학교설명회</span>가 진행됩니다.</p>
          <p>학교 홈페이지를 통해 신청하실 수 있습니다.</p>
          <p className="bold">자세한 내용은 아래를 참고해주세요.</p>
        </div>
        {/* <a href="https://www.minjok.hs.kr/sub05_01_01.php#post_id=1199" rel="noreferrer" target="_blank" className="button regular"> */}
        <a href={AdmissionInformationSession} rel="noreferrer" target="_blank" className="button regular">
          온라인 학교설명회 안내
        </a>
        <div className="divider"></div>
      </div>
      <div className="section">
        <div className="section-title light">5. 문의 및 상담 : 민사고 입학관리실</div>
        <div className="contact-info regular">
          <p>070-4742-0100</p>
          <p>iphak@minjok.hs.kr</p>
        </div>
        <a href="https://www.minjok.hs.kr/sub04_01_01.php" rel="noreferrer" target="_blank" className="button regular">
          입시요강 자세히 보기
        </a>
      </div>
      <footer className="footer">
        <p className="light">Copyright 1996-2020 KMLA, All rights reserved.</p>
        <p className="light">More information, contact webmaster</p>
        <p className="regular">25268, 강원도 횡성군 안흥면 봉화로 800 민족사관고등학교</p>
        <p className="regular">Tel : 033-343-1115 Fax : 033-342-8660</p>
      </footer>
    </div>
  );
}

export default App;
